exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".convertableContainer__3oVu {\n  padding: 0; }\n\n.pageContainer__2APa {\n  padding: 20px; }\n\n.container__2vWQ {\n  width: 100%;\n  padding: 0; }\n", "", {"version":3,"sources":["/app/src/ui/alert-dialog/src/ui/alert-dialog/mobile-tour.scss"],"names":[],"mappings":"AAAA;EACE,WAAW,EACZ;;AAED;EACE,cAAc,EACf;;AAED;EACE,YAAY;EACZ,WAAW,EACZ","file":"mobile-tour.scss","sourcesContent":[".convertableContainer {\n  padding: 0;\n}\n\n.pageContainer {\n  padding: 20px;\n}\n\n.container {\n  width: 100%;\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"convertableContainer": "convertableContainer__3oVu",
	"pageContainer": "pageContainer__2APa",
	"container": "container__2vWQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/alert-dialog/mobile-tour.scss
// module id = 1066
// module chunks = 0